import React, { Component } from 'react'
import { connect } from 'react-redux'
import history from '../../../routes/history';
import * as actionCreator from '../../../redux/actions/data-action';
import connectCommon from '../../common/common-hoc';
import { assessmentStatus, termsReponse } from '../../../Constants';

import {
    AssessmentContainer,
    AssessmentContentCenteredSection,
    AssessmentBody,
    AssessmentContent,
    AssessmentContentHeader,
    AssessmentNavigationPrevious,
    AssessmentNavigationNext,
    AssessmentFooter,
    AssessmentContentError,
    AssessmentContentAction,
    AssessmentContentActionButton
} from '../../assessment/common';

const backLink = "/TermsAndConditions";
const nextLink = "/FinalTermination";

class TermsDeclineScreenSpanish extends Component {
    constructor(props) {
        super(props);

        this.state = { errorMessage: '' };

        this.handleBack = this.handleBack.bind(this);
        this.handleNext = this.handleNext.bind(this);
    }

    handleBack() {
        const { setTerms, setAssessmentStatus } = this.props;
        setAssessmentStatus(assessmentStatus.InProgress);
        history.push(backLink);
    }

    handleNext() {
        this.setState({ errorMessage: 'Please provide a response' });
    }

    render() {
        return (
            <AssessmentContainer>
                <AssessmentContentHeader></AssessmentContentHeader>
                <AssessmentBody>
                    <AssessmentContent>
                        <AssessmentContentCenteredSection>
                            Usted ha renunciado a contestar Conners 4™. Para mas información, por favor contacte su Administrador de Conners 4™.
                        </AssessmentContentCenteredSection>
                        <AssessmentContentCenteredSection>
                            Si a usted le gustaría contestar Conners 4™, por favor regrese a la página de información legal y haga clic en "Yo acepto" para continuar.
                        </AssessmentContentCenteredSection>
                        <AssessmentContentError>
                            {this.state.errorMessage}
                        </AssessmentContentError>
                        <AssessmentContentAction>
                        <AssessmentContentActionButton styleType='arrows' onClick={this.handleBack}>{'<'}</AssessmentContentActionButton>
                            {/* <AssessmentContentActionButton onClick={this.handleExit}>Close</AssessmentContentActionButton> */}
                        </AssessmentContentAction>
                    </AssessmentContent>
                </AssessmentBody>
                <AssessmentFooter includeProgress={false} includeLogo={true}></AssessmentFooter>
            </AssessmentContainer>
        )
    }
}

export default connect(null, actionCreator)(connectCommon(TermsDeclineScreenSpanish));